import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { GetLinks } from 'domain/usecases/get-links';
import { RemoteGetLinks } from 'data/usecases/remote-get-links';

export const makeRemoteGetLinks = (): GetLinks => {
  return new RemoteGetLinks(makeApiUrl('/links'), makeAuthorizeHttpClientDecorator());
};
